import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { Messages } from 'src/app/constants/messages';
import {
  ButtonType,
  DialogModel
} from 'src/app/model';
import { GeneralService } from './general.service';
import { DialogComponent } from 'src/app/shared/components';

@Injectable()
export class DialogService {

  constructor(
    private _dialog: MatDialog,
    private _generalService: GeneralService
  ) { }

  /**
   * Shows dialog
   * @param config
   */
  showDialog(config: MatDialogConfig<DialogModel>) {
    // Default configurations of dialog
    config = {
      data: {
        title: Messages.DIALOG_TITLE_DEFAULT,
        showClose: true,
        showAction: true,
        actions: [
          {
            label: Messages?.BUTTON_LABEL_OK,
            type: ButtonType?.BUTTON,
            value: true
          }
        ],
        ...config?.data
      },
      disableClose: config?.disableClose ?? true,
      panelClass: config?.panelClass ?? 'full-screen-modal',
      width: config?.width ?? '25%',
      ...(this._generalService?.removePropertyFromObject(config, 'data'))
    };
    // Calling Dialog
    return this._dialog.open(
      DialogComponent, 
      { ...config }
    );
  }

}
